module.exports = __webpack_public_path__ + "close.svg?a1a38e857db8ac7075d85ed66e10873b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = 117
// module chunks = 0